<div class="row  my-2 align-items-center justify-content-center tarjeta-documento">
  <div class="col-2 text-center">
    @if (pdfRegex.test(tipoArchivo)) {
      <mat-icon class="txt-primario" style="font-size: 1.5rem;"
      >description</mat-icon>
    }
    @if (imgRegex.test(tipoArchivo)) {
      <mat-icon class="txt-primario" style="font-size: 1.5rem;">image</mat-icon>
    }
    @if (!imgRegex.test(tipoArchivo) && !pdfRegex.test(tipoArchivo)) {
      <mat-icon class="txt-primario" style="font-size: 1.5rem;"
      >description</mat-icon>
    }
  </div>
  @if (datoArchivo && acciones) {
    <div class="col">
      @if (datoArchivo?.DescDocumento) {
        <p class="fw-bold col-12 m-0">{{datoArchivo.DescDocumento}}</p>
      }
      @if (datoArchivo?.NombreDocumento) {
        <p class="fw-bold col-12 m-0">{{datoArchivo.NombreDocumento}}</p>
      }
    </div>
  }
  @if (!datoArchivo && !acciones) {
    <div class="col mt-3">
      @if (nombreArchivo) {
        <p><span class="fw-bold">Nombre del documento: </span>{{nombreArchivo}}</p>
      }
      @if (fechaArchivo) {
        <p class="col-12"><span class="fw-bold">Fecha de Carga: </span> <span
      class="titulo">{{fechaArchivo}}</span>
    </p>
  }
</div>
}
<div class="col-2 d-flex justify-content-end">
  <ng-content select="[btnEliminarArchivo]"></ng-content>
</div>
</div>